import {AccountUserModel} from '@/Pages/Admin/Modules/Models/ManageAccount/AccountUserModel';

export class AccountUserProfileModel {
    public id: number;
    public account_user_id: number;
    public address_line1: string;
    public address_line2: string;
    public profile_image: string;
    public city: string;
    public province: string;
    public country: string;
    public zip: number;
    public mobile1: string;
    public mobile2: string;
    public contact_person: string;
    public contact_person_mobile: string;
    public account_user: AccountUserModel = new AccountUserModel({});
    public created_at: string;
    public updated_at: string;

    constructor(obj: any) {
        this.id = obj.id ? obj.id : 0;
        this.account_user_id = obj.account_user_id ? obj.account_user_id : 0;
        this.address_line1 = obj.address_line1 ? obj.address_line1 : '';
        this.address_line2 = obj.address_line2 ? obj.address_line2 : '';
        this.profile_image = obj.profile_image ? obj.profile_image : '';
        this.city = obj.city ? obj.city : '';
        this.province = obj.province ? obj.province : '';
        this.country = obj.country ? obj.country : '';
        this.zip = obj.zip ? obj.zip : 0;
        this.mobile1 = obj.mobile1 ? obj.mobile1 : '';
        this.mobile2 = obj.mobile2 ? obj.mobile2 : '';
        this.contact_person = obj.contact_person ? obj.contact_person : '';
        this.contact_person_mobile = obj.contact_person_mobile ? obj.contact_person_mobile : '';
        this.account_user = obj.account_user ? obj.account_user : new AccountUserModel({});
        this.created_at = obj.created_at ? obj.created_at : '';
        this.updated_at = obj.updated_at ? obj.updated_at : '';
    }
}
